import { CommonModule, Location } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';

@Component({
  selector: 'app-report-header',
  imports: [ButtonModule, DatePickerModule, CommonModule, FormsModule],
  templateUrl: './report-header.component.html'
})
export class ReportHeaderComponent {

  @Input() getDataFunc!: () => void;
  @Input() exportFunc!: () => void;
  @Output() dateChange = new EventEmitter<{ initialDate: Date; finalDate: Date }>();

  constructor(private location: Location){

  }

  currentDate = new Date();
  initialDate: Date = this.currentDate;
  finalDate: Date = this.currentDate;

  getData(){
    this.dateChange.emit({ initialDate: this.initialDate, finalDate: this.finalDate });
    this.getDataFunc();
  }

  export(){
    this.exportFunc();
  }

   goBack() {
    this.location.back();
  }
}
